import { Injectable } from '@angular/core';
import { environment, PATHS } from '@asambleas-env/environment';
import { GeneralService } from '@asambleas-services/general/general.service';
import { HttpClient } from '@angular/common/http';
import { Role } from '@asambleas-models/role.model';

@Injectable()
export class RolesService {

    constructor(private http: HttpClient,
        private _generalService: GeneralService) { }

    // EL NIVEL 1 NO NECESITA ESTA INFO
    getRolData(rol: Role) {
        if (rol.level == '2') {
            return this.getDirectorDistrital(rol.pivot.id);
        }
    }

    getDirectorDistrital(id: number) {
        return this.http.get(environment.apiEndPoint + '/roles/axis-district/' + id, this._generalService.getHeadersUser())
    }

    getSectionalCoordinatorPastoral(id: number) {
        return this.http.get(environment.apiEndPoint + '/roles/sectional-coordinator-pastoral/' + id, this._generalService.getHeadersUser())
    }

    /**
     * Obtiene los roles del sistema como una lista de elementos
     *
     * @returns
     * @memberof RolesService
     */
    getRolesAsList() {
        return this.http.get(environment.apiEndPoint + '/roles/all', this._generalService.getHeadersUser())
    }

    updateUseRole(body: any) {
        return this.http.post(environment.apiEndPoint + '/roles/update/user', body, this._generalService.getHeadersUser())
    }

    highestRol(roles: Role[]): Role {
        let response: Role;

        roles.forEach((role) => {
            if (!response) {
                response = role;
            }
            else {
                if (role.id < response.id) {
                    response = role;
                }
            }
        })

        return response;
    }

    getMyhighestRol(): Role {
        let user = JSON.parse(localStorage.getItem('user'));

        if (user && user.roles) {
            let roles = user.roles;

            let response: Role;

            roles.forEach((role) => {
                if (!response) {
                    response = role;
                }
                else {
                    if (role.id < response.id) {
                        response = role;
                    }
                }
            })

            return response;
        }
        else {
            return null;
        }
    }

}



// WEBPACK FOOTER //
// ./src/app/services/roles/roles.service.ts